import { render, staticRenderFns } from "./UiToggle.vue?vue&type=template&id=3372bf3c"
import script from "./UiToggle.vue?vue&type=script&lang=js"
export * from "./UiToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports